var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Transition", { attrs: { name: "fade-fast" } }, [
    _vm.currentError !== null
      ? _c(
          "div",
          {
            staticClass:
              "error-view-z-index w-100 position-absolute top-0 left-0",
            class: {
              "br-8 border-white border-dashed border-1 h-100": _vm.mode,
              "h-100": !_vm.mode,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
              },
            },
          },
          [
            _vm.currentError.type === _vm.ERROR_TYPE.GENERIC
              ? _c("ErrorGenericView", {
                  attrs: {
                    title: _vm.currentError.title,
                    description: _vm.currentError.description,
                    "can-dismiss": _vm.currentError.canDismiss,
                    "show-try-premium-button":
                      _vm.currentError.showTryPremiumButton,
                    "show-start-button": _vm.currentError.showStartButton,
                    "is-state-loading": _vm.isStateLoading,
                    "button-text": _vm.premiumText,
                    "back-button-text": _vm._f("trans")("No thanks"),
                  },
                  on: {
                    dismiss: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    },
                    "generic-action": function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handlePayment.apply(null, arguments)
                    },
                    "start-task": function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.startConversion.apply(null, arguments)
                    },
                  },
                })
              : _vm.currentError.type === _vm.ERROR_TYPE.COUNTDOWN
              ? _c("ErrorCountdownView", {
                  attrs: {
                    "is-state-loading": _vm.isStateLoading,
                    "show-try-premium-button":
                      _vm.currentError.showTryPremiumButton,
                    "show-start-button": _vm.currentError.showStartButton,
                    "current-error": _vm.currentError,
                  },
                  on: {
                    dismiss: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    },
                    "generic-action": function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handlePayment.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }